import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { router } from './app/router';
import { AuthProvider } from './features/auth/AuthProvider';
import { PhoneProvider } from './features/phone/PhoneProvider';
import { usePublicConfig } from './features/phone/usePublicConfig';
import { ThemeProvider, useTheme } from './features/theme/ThemeProvider';
import './styles.css';

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: 1,
			staleTime: 30000
		}
	}
});

function PhoneProviderWithConfig({ children }: { children: React.ReactNode }) {
	const pbxConfig = usePublicConfig();
	return <PhoneProvider pbxConfig={pbxConfig}>{children}</PhoneProvider>;
}

function ThemedToaster() {
	const { theme } = useTheme();
	return <Toaster position="top-right" richColors theme={theme} closeButton />;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<React.StrictMode>
		<ThemeProvider>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<PhoneProviderWithConfig>
						<RouterProvider router={router} />
					</PhoneProviderWithConfig>
					<ThemedToaster />
				</AuthProvider>
			</QueryClientProvider>
		</ThemeProvider>
	</React.StrictMode>
);
